import Sidebar from "./Sidebar";
import Header from "./Header";
import { NetworkStatusIndicator } from "@/components/ui/network-status";

/**
 * Owner workspace frame. One compact title row per page; `actions` holds the
 * page's primary action (top right). `eyebrow`/`subtitle` are accepted for
 * older pages but no longer shown — the redesign keeps pages quiet.
 */
export default function PageLayout({ children, title, actions, onRefresh, isRefreshing, hideTitle = false }) {
  return (
    <div className="owner-app">
      <a className="skip-link" href="#workspace-content">
        Skip to content
      </a>
      <Sidebar />
      <NetworkStatusIndicator />
      <div className="owner-main">
        <Header title={title} onRefresh={onRefresh} isRefreshing={isRefreshing} />
        <main id="workspace-content" className="owner-content">
          {!hideTitle && (title || actions) ? (
            <div className="owner-title-row">
              <h1>{title}</h1>
              {actions ? <div className="owner-title-actions">{actions}</div> : null}
            </div>
          ) : null}
          {children}
        </main>
      </div>
    </div>
  );
}
